import {
  type AccountId,
  accountIdFormat,
  freightPickupWindowIdFormat,
} from "@redotech/redo-ids/ids";
import { plainTime } from "@redotech/rpc/ext";
import * as z from "zod";

const FreightPickupWindowRowSchema_ = z.object({
  id: freightPickupWindowIdFormat.schema,
  accountId: accountIdFormat.schema,
  name: z.string(),
  pickupReadyTime: plainTime(),
  pickupCloseTime: plainTime(),
  isDefault: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const FreightPickupWindowRowSchema: z.ZodType<FreightPickupWindowRow> =
  FreightPickupWindowRowSchema_;
export interface FreightPickupWindowRow
  extends z.infer<typeof FreightPickupWindowRowSchema_> {}

export interface CreateFreightPickupWindowInput {
  accountId: AccountId;
  name: string;
  pickupReadyTime: Temporal.PlainTime;
  pickupCloseTime: Temporal.PlainTime;
  isDefault?: boolean;
}

export interface UpdateFreightPickupWindowInput {
  name?: string;
  pickupReadyTime?: Temporal.PlainTime;
  pickupCloseTime?: Temporal.PlainTime;
  isDefault?: boolean;
}
